import React from 'react'
import Curriculum from './Curriculum'
import ResourceLibrary from './ResourceLibrary'

function SectionOneWrapper() {
  return (
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
      <Curriculum/>
      <ResourceLibrary/>
    </div>
  )
}

export default SectionOneWrapper
